// LemmaParseHeadUtils.js (updated with support for lemma_chs expanded details)
import React, { useState } from 'react';
import { SpeakTextButton,LemmaAudioPlayer } from './LemmaPlayUtils';
import './LemmaParseHeadUtilstyle.css';

const FreLemmaDisplay = ({ lemmashead, lemmafre = '[]',headword, showlemma, langcodename}) => {
  const [tempShow, setTempShow] = useState(false);
  const [showMore, setShowMore] = useState(false);

  if (!lemmashead) return null;

  const parse_head = (lemmasHead) => {
    let parsedHead = [];
    try {
      parsedHead = JSON.parse(lemmasHead);
    } catch (error) {
      console.error("Error parsing lemmasHead:", error);
      return <div>Invalid lemmashead format.</div>;
    }

    if (!Array.isArray(parsedHead)) {
      return <div>No lemma lemmashead available.</div>;
    }
    //console.log('The entire parsedHead array:', parsedHead); // Assuming parsedHead is defined
    return parsedHead.map(({subject:subject_pos, definition_fr, definition_en }, index) => (
      <div key={index} className="mb-2">
        <div><strong>{index + 1}:</strong> {subject_pos}</div>
        <div className="en-def"><strong></strong> {definition_fr.value}

          <LemmaAudioPlayer aidurl={definition_fr.aid} aidtext={definition_fr.value} />
        </div>
        <div className="chs-def"><strong></strong> {definition_en.value}

          <LemmaAudioPlayer aidurl={definition_en.aid} aidtext={definition_en.value} />
        </div>
      </div>
    ));
  };

  const parseExamples = (examples = []) => {
    if (!Array.isArray(examples) || examples.length === 0) return null;
  
    return (
      <div className="ld-examples">
        <strong>Examples:</strong>
        <ul>
          {examples.map((example, idx) => (
            <li key={idx}>
              {example}
              <SpeakTextButton headword={example} />
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const parseHeadwordExamples = (examples = [], headword = '') => {
    if (!Array.isArray(examples) || examples.length === 0 || !headword) return null;
  
    const lowerHeadword = headword.toLowerCase();
  
    // Filter examples containing the headword (case-insensitive)
    const filtered = examples.filter(example =>
      example.toLowerCase().includes(lowerHeadword)
    );
  
    if (filtered.length === 0) return null;
  
    return (
      <div className="ld-examples">
        <strong>Examples:</strong>
        <ul>
          {filtered.map((example, idx) => (
            <li key={idx}>
              {example}
              <SpeakTextButton headword={example} />
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const parseHeadwordExamplesWithFre = (examples_def_fr = [], examples_def_en = [], headword = '') => {
    if (!Array.isArray(examples_def_fr) || examples_def_fr.length === 0 || !headword) return null;
    //do not use this logic to find matched indexes, the examples_def_en and examples_def_fr share same index with same content.
    // const lowerHeadword = headword.toLowerCase();
  
    // Find matched indexes
    // const matchedIndexes = examples_def_fr
    //   .map((example, idx) => example.value.toLowerCase().includes(lowerHeadword) ? idx : -1)
    //   .filter(idx => idx !== -1);
  
    // if (matchedIndexes.length === 0) return null;
  
    return (
      <div className="ld-examples">
        {/* <strong>Examples:</strong> */}
         <strong></strong>
        <ul>
          {examples_def_fr.map((_,idx) => (
            <li key={idx}>
              {/* English example */}
              {examples_def_fr[idx].value}
              <LemmaAudioPlayer aidurl={examples_def_fr[idx].aid} aidtext={examples_def_fr[idx].value} />
              {/* Mandarin example if exists */}
              {examples_def_en[idx] && (
                <>
                  <div style={{ marginTop: '4px', color: '#666' }}>
                    {examples_def_en[idx].value}
                    <LemmaAudioPlayer aidurl={examples_def_en[idx].aid} aidtext={examples_def_en[idx].value} />
                  </div>
                </>
              )}
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const parse_lemma_fre = (lemmaChsData) => {
    let parsed = [];
    try {
      parsed = JSON.parse(lemmaChsData);
    } catch (error) {
      console.error("Error parsing lemma_chs:", error);
      return <div>Invalid more lemma data.</div>;
    }

    if (!Array.isArray(parsed)) {
      return <div>No additional lemma data.</div>;
    }

    parsed.sort((a, b) => {
      const aSub = (a.subject || '').split('.')[0];
      const bSub = (b.subject || '').split('.')[0];
      return aSub.localeCompare(bSub);
    });
    //console.log('The entire lemma_fre array:', parsed); // Assuming parsedHead is defined
    return parsed.map((item, index) => (
      <div key={`chs-${index}`} className="ld-expanded-block">
        <div><strong>{index + 1}:</strong> {(item.subject || '').split('.')[0]}</div>
        <div className="en-def"><strong></strong> {item.definition_fr.value}
          <LemmaAudioPlayer aidurl={item.definition_fr.aid} aidtext={item.definition_fr.value} />
        </div>
        <div className="chs-def"><strong></strong> {item.definition_en.value}
          <LemmaAudioPlayer aidurl={item.definition_en.aid} aidtext={item.definition_en.value} />
        </div>
        {parseHeadwordExamplesWithFre(item.examples_def_fr,item.examples_def_en,headword)}
      </div>
    ));
  };

  return (
<div className="spStoreAddress">
  {(showlemma === 1 || tempShow) ? (
    <>
      {parse_head(lemmashead)}
      
      {/* --- THIS IS THE NEW UNIFIED BUTTON --- */}
      <button 
        className={`ld-show-more-btn ${showMore ? 'expanded' : ''}`} 
        onClick={() => setShowMore(!showMore)}
      >
        <span>{showMore ? 'Show less' : 'Show more'}</span>
        <i className="chevron"></i>
      </button>

      {/* This part remains the same: it only shows when showMore is true */}
      {showMore && parse_lemma_fre(lemmafre)}
    </>
  ) : (
    // We can style this initial "click to show" prompt to be consistent too
    <div className="blurred-lemma" onClick={() => setTempShow(true)}>
      Enable lemma
    </div>
  )}
</div>
  );
};

export default FreLemmaDisplay;
